import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const EmailOpen = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M19.875 10.5V18.9375C19.875 19.2359 19.7565 19.522 19.5455 19.733C19.3345 19.944 19.0484 20.0625 18.75 20.0625H5.25C4.95163 20.0625 4.66548 19.944 4.4545 19.733C4.24353 19.522 4.125 19.2359 4.125 18.9375V10.5L10.6103 15.6442C11.0066 15.9555 11.496 16.1248 12 16.1248C12.504 16.1248 12.9934 15.9555 13.3897 15.6442L19.875 10.5Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.875 10.5002L13.6447 5.0252C13.4342 4.79968 13.1796 4.61987 12.8967 4.49693C12.6137 4.37399 12.3085 4.31055 12 4.31055C11.6915 4.31055 11.3863 4.37399 11.1033 4.49693C10.8204 4.61987 10.5658 4.79968 10.3553 5.0252L4.125 10.5002"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.856 14.481L17.0625 16.6875"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.144 14.481L6.9375 16.6875"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
